import React, { useState } from 'react';
import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Button,
  CircularProgress,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useUser } from '@/providers';
import { createApiKey } from '@/actions/user';
import ApiKey from './ApiKey';

export default function ApiKeysForm() {
  const user = useUser();
  const [submitting, setSubmitting] = useState(false);

  const createNewApiKey = async () => {
    setSubmitting(true);
    try {
      await createApiKey();
      // Refetch user to get updated API keys
      // Layout will handle refetching
    } catch (error) {
      console.error('Error creating API key:', error);
    }
    setSubmitting(false);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 12, lg: 12 }}>
        <Button
          variant='contained'
          color='brand'
          startIcon={submitting ? <CircularProgress size={20} /> : <AddIcon />}
          onClick={createNewApiKey}
          disabled={submitting}
        >
          Create
        </Button>
      </Grid>
      <Grid size={{ xs: 12, md: 12, lg: 12 }}>
        {user.api_keys && user.api_keys.length ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell align='center'>Created</TableCell>
                  <TableCell align='center'>Age</TableCell>
                  <TableCell align='center'>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {user.api_keys.map((key) => (
                  <ApiKey key={key.id} api_key={key} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Alert severity='info'>No keys configured.</Alert>
        )}
      </Grid>
    </Grid>
  );
}
